/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    
    /**
     * Factory callback type
     */
    declare type InlineEditDirectiveFactoryCb = () => InlineEditDirective;
    
    /**
     * Custom scope
     */
    export interface IInlineEditDirectiveScopeDef {
        model: string;
        width: string;
        onSave: string;
        property: string;
    }
    
    /**
     * Custom scope
     */
    export interface IInlineEditDirectiveScope extends ng.IScope {
        model: Models.ITopologyElement;
        width: number;
        onSave: () => void;
        property: string;
        editMode: boolean;
        showEdit: boolean;
        edit(): void;
        cancel(): void;
        save(): void;
    }
    
    /**
     * Bar directive
     */
    export class InlineEditDirective implements ng.IDirective {
        public static $name: string = "inlineEdit";
        public static $inject: string[] = [];
        
        public link: (scope: IInlineEditDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/inline-edit-directive.html';
        public scope: IInlineEditDirectiveScopeDef = {
            model: '=',
            width: '@',
            onSave: '&',
            property: '@',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): InlineEditDirectiveFactoryCb {
            let directive: InlineEditDirectiveFactoryCb = () => {
                return new InlineEditDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            InlineEditDirective.prototype.link = (scope: IInlineEditDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                scope.editMode = scope.showEdit = false;
                let previousValue: string;
                
                scope.edit = function(): void {
                    scope.editMode = true;
                    previousValue = scope.model[scope.property];
                    element.find('input')[0].focus();
                };
                
                scope.cancel = function(): void {
                    // tODO: HACK to avoid an enter been interpreted as a cancel. To be checked
                    if (typeof previousValue !== 'undefined')
                        scope.model[scope.property] = previousValue;
                    
                    scope.editMode = false;
                };
                
                scope.save = function(): void {
                    // raises the onSave event
                    if (scope.onSave !== undefined) {
                        scope.onSave();
                    }
                    
                    scope.editMode = false;
                };
            };
        }
    }
}
